/**
 * Layout: sidebar organizzata sul flusso decisionale (5 sezioni) + header.
 */
import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const NAV = [
  {
    group: "Pianificazione",
    items: [
      { to: "/fabbisogno", label: "Fabbisogno", icon: "📊" },
      { to: "/copertura", label: "Copertura ideale", icon: "🕘" },
      { to: "/fattibilita", label: "Fattibilità", icon: "✅" },
      { to: "/piano-turni", label: "Piano turni", icon: "📅", disabled: true },
    ],
  },
  {
    group: "Rendicontazione",
    items: [
      {
        to: "/costo-personale",
        label: "Costo personale",
        icon: "💶",
      },
      {
        to: "/costo-personale/import",
        label: "Import dati",
        icon: "📤",
      },
      {
        to: "/costo-personale/confronto",
        label: "Confronto RSA",
        icon: "⚖️",
      },
    ],
  },
  {
    group: "Configurazione",
    items: [
      { to: "/normative", label: "Normative", icon: "📋" },
      { to: "/impostazioni", label: "Impostazioni", icon: "⚙️" },
    ],
  },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <aside className="w-60 bg-white border-r border-gray-200 flex flex-col">
        <div className="px-4 py-4 border-b border-gray-100">
          <h1 className="font-bold text-primary-700 text-lg">PHC HR</h1>
          <p className="text-xs text-gray-500">Pianificazione personale RSA</p>
        </div>
        <nav className="flex-1 px-2 py-3 space-y-4">
          {NAV.map((section) => (
            <div key={section.group}>
              <p className="px-2 text-xs font-semibold text-gray-400 uppercase mb-1">
                {section.group}
              </p>
              {section.items.map((item) =>
                item.disabled ? (
                  <span
                    key={item.to}
                    className="flex items-center gap-2 px-2 py-1.5 rounded text-sm text-gray-300 cursor-not-allowed"
                    title="In arrivo (fase 2)"
                  >
                    <span>{item.icon}</span> {item.label}
                    <span className="ml-auto text-[10px] bg-gray-100 px-1 rounded">
                      fase 2
                    </span>
                  </span>
                ) : (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === "/costo-personale"}
                    className={({ isActive }) =>
                      `flex items-center gap-2 px-2 py-1.5 rounded text-sm ${
                        isActive
                          ? "bg-primary-50 text-primary-700 font-medium"
                          : "text-gray-600 hover:bg-gray-100"
                      }`
                    }
                  >
                    <span>{item.icon}</span> {item.label}
                  </NavLink>
                ),
              )}
            </div>
          ))}
        </nav>
        <div className="px-4 py-3 border-t border-gray-100 text-sm">
          <p className="font-medium text-gray-700 truncate">
            {user?.displayName || user?.email}
          </p>
          <p className="text-xs text-gray-400">{user?.ruoloLabel}</p>
          <button
            onClick={async () => {
              await logout();
              navigate("/login");
            }}
            className="mt-2 text-xs text-red-600 hover:underline"
          >
            Esci
          </button>
        </div>
      </aside>
      <main className="flex-1 p-6 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
